module.exports = __webpack_public_path__ + "img/train de voyageur.ec9c51cf.png";